import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../Components/InnerLayout/Headerbar";
const InventorySummary = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
      <div className="inner-content row">
        <div className="container d-flex flex-wrap">
            <div class="shadowclass">
              <p>
                The Inventory Module can be flexible to accommodate your Inventory
                Management process:
              </p>
              <ul className="sm-list">
                <li>
                  <strong>Analog or digital stock counting</strong> – If your
                  restaurant doesn’t have a mobile device available for the stock
                  count, you can print the latest stock sheet from the system and
                  input the stocks later when you are back at your desktop/laptop.
                </li>
                <li>
                  <strong>Frequency</strong> – GoGMGo will automatically add the
                  stock amounts with orders created in the Order screen. The
                  subsequent count will show the expected stock usage, so the
                  longer the period between checks, the more important it is for
                  the manager to check the Variance Summary screen to make sure
                  inventory levels are not far from expectations (expected amounts
                  based-on sales volumes or perpetual check-in/check-out amounts).
                  We recommend performing perpetual inventory management by
                  closely tracking incoming and outgoing supplies and
                  supplementing that process with at least one monthly stock count
                  using a mobile device.
                </li>
                <li>
                  <strong>Email supplier orders</strong> – Bulk-order supplies via
                  email from multiple suppliers with the single push of a button.
                </li>
                <li>
                  <strong>
                    Manual or automated determination of order amounts
                  </strong>{" "}
                  – User may choose 2 different order approaches:
                  <ul>
                    <li>
                      - Manual – Blank order amount fields in the order sheets for
                      users to define how much needs to be ordered.
                    </li>
                    <li>
                      {" "}
                      - Saved Favorites – Have a recurring order with your regular
                      supplier? No problem, click on the “star” icon next to your
                      regular order to save it as a “Favorite” order template.{" "}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="shadowclass">
              <h4 class="event-alert green-text">GM Inventory Management Process</h4>
              <img src="/img/inventory-step1-1.png" class="img-responsive" />
            </div>

            
            <div className="row mx-0 w-100">
              <div class="btns d-flex justify-content-end py-4 col-12 px-0">
                <button type="Submit"> Next </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default InventorySummary;
